module.exports = __webpack_public_path__ + "static/media/ativar_provas.7294c46e.png";